// extracted by mini-css-extract-plugin
export default {"modalContainer":"BulkUpload_modalContainer__w1zT3","contentWrapper":"BulkUpload_contentWrapper__h4zyw","button":"BulkUpload_button__T4gQ1","file":"BulkUpload_file__KkoJZ"};